import {
  SDS_CANONICAL_CAS,
  SDS_CANONICAL_CLASSIFICATION_HAZARDCLASS,
  SDS_CANONICAL_CLASSIFICATION_CATEGORY,
  SDS_CANONICAL_CLASSIFICATION_ROUTE_OF_EXPOSURE,
  SDS_CANONICAL_CLASSIFICATION_TARGET_ORGAN,
  SDS_CANONICAL_CLASSIFICATION_HAZARD_STATEMENT,
  SDS_CANONICAL_CLASSIFICATION_ADDITIONAL_INFO,
  SDS_CANONICAL_CLASSIFICATION_REMARKS,
  SDS_CANONICAL_EG_NO,
  SDS_CANONICAL_INDEX_NR,
  SDS_CANONICAL_NAME,
  SDS_CANONICAL_PICTOGRAM,
  SDS_CANONICAL_PICTOGRAM_LABELLING,
  SDS_CANONICAL_SPEC_NAME,
  SDS_CANONICAL_THRESHOLD,
  SDS_CANONICAL_TEXT,
  SDS_CANONICAL_SPEC_ID,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_BASE,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_LIMIT,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_CLASS,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_CATEGORY,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_ROUTE_EXPO,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_ORGAN,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_HAZ_STATEMENT,
  SEC_CANONICAL_CONCENTRATION_SAIFTY_ADD_INFO,
  SEC_CANONICAL_M_FACTOR_SAIFTY_BASE,
  SEC_CANONICAL_M_FACTOR_SAIFTY_M_FACTOR,
  SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_CHRONIC,
  SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_SOIL,
  SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_VERT,
  SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_INVERT,
  SEC_CANONICAL_M_FACTOR_SAIFTY_REMARK,
  SEC_CANONICAL_WGK_SAIFTY_BASE,
  SEC_CANONICAL_WGK_SAIFTY_HAZARD_CLASS,
  SEC_CANONICAL_WGK_SAIFTY_IDENT_NUM,
  SDS_CANONICAL_WATER_HAZARD_CLASS,
  SIMULATION_TYPE_IDENTIFIER,
  SDS_CANONICAL_M_FACTOR,
  SDS_CANONICAL_CONCENTRATION,
} from '@/config'
import { CanonicalsConfigObject } from '@coac-gmbh/saifty-phrases'

export enum TemplateType {
  Regular = 'Regular',
  Simulation = 'Simulation',
}

export const DEFAULT_SIMULATION_TOOL_LANGUAGE = window.ENV.DEFAULT_SIMULATION_TOOL_LANGUAGE

// We need to ignore these items on sync to SAP
export const CANONICALS_CONTROL_LIST_TO_IGNORE = [
  SDS_CANONICAL_CAS,
  SDS_CANONICAL_EG_NO,
  SDS_CANONICAL_INDEX_NR,
  SDS_CANONICAL_SPEC_ID,
  SDS_CANONICAL_NAME,
]

export const CANONICALS_TO_GROUP_UNDER_THE_SAME_FIELD = [
  SDS_CANONICAL_CLASSIFICATION_HAZARDCLASS,
  SDS_CANONICAL_CLASSIFICATION_CATEGORY,
  SDS_CANONICAL_CLASSIFICATION_HAZARD_STATEMENT,
  SDS_CANONICAL_CLASSIFICATION_ROUTE_OF_EXPOSURE,
  SDS_CANONICAL_CLASSIFICATION_TARGET_ORGAN,
  SDS_CANONICAL_CLASSIFICATION_ADDITIONAL_INFO,
  SDS_CANONICAL_CLASSIFICATION_REMARKS,
]

export const SPECIAL_CHARACTER_TO_GROUP_ITEMS = ','
export const SPECIAL_CHARACTER_TO_GROUP_SUBCANONICAL_AND_VALUE = ':'

export const CANONICALS_TO_CONCAT_UNDER_THE_SAME_FIELD = [SDS_CANONICAL_PICTOGRAM, SDS_CANONICAL_PICTOGRAM_LABELLING]
export const CANONICALS_PREFIXES_WITH_SUBCANONICALS = [
  SDS_CANONICAL_CONCENTRATION,
  SDS_CANONICAL_M_FACTOR,
  SDS_CANONICAL_WATER_HAZARD_CLASS,
]

export const canonicalNameColumnIndex = 1
export const XLSXCanonicalByPosition: { [key: number]: string } = {
  0: SDS_CANONICAL_INDEX_NR,
  [canonicalNameColumnIndex]: SDS_CANONICAL_NAME,
  2: SDS_CANONICAL_EG_NO,
  3: SDS_CANONICAL_CAS,
  4: SDS_CANONICAL_CLASSIFICATION_HAZARDCLASS,
  5: SDS_CANONICAL_CLASSIFICATION_CATEGORY,
  6: SDS_CANONICAL_CLASSIFICATION_HAZARD_STATEMENT,
  7: SDS_CANONICAL_PICTOGRAM,
  8: SDS_CANONICAL_PICTOGRAM_LABELLING,
  9: SDS_CANONICAL_SPEC_NAME,
  10: SDS_CANONICAL_THRESHOLD,
  11: SDS_CANONICAL_TEXT,
}

export const canonicalNameColumnIndexForSimulationTemplate = 4
export const XLSXCanonicalByPositionSimulationTemplate: { [key: number]: string } = {
  0: SDS_CANONICAL_CAS,
  1: SDS_CANONICAL_EG_NO,
  2: SDS_CANONICAL_INDEX_NR,
  3: SDS_CANONICAL_SPEC_ID,
  4: SDS_CANONICAL_NAME,
  5: SIMULATION_TYPE_IDENTIFIER,
  6: SDS_CANONICAL_CLASSIFICATION_HAZARDCLASS,
  7: SDS_CANONICAL_CLASSIFICATION_CATEGORY,
  8: SDS_CANONICAL_CLASSIFICATION_ROUTE_OF_EXPOSURE,
  9: SDS_CANONICAL_CLASSIFICATION_TARGET_ORGAN,
  10: SDS_CANONICAL_CLASSIFICATION_HAZARD_STATEMENT,
  11: SDS_CANONICAL_CLASSIFICATION_ADDITIONAL_INFO,
  12: SDS_CANONICAL_CLASSIFICATION_REMARKS,
  13: SEC_CANONICAL_CONCENTRATION_SAIFTY_BASE, // 14) Phrase: Regulatory List
  14: SEC_CANONICAL_CONCENTRATION_SAIFTY_LIMIT, // 15) Phrase: Concentration Limit in %
  15: SEC_CANONICAL_CONCENTRATION_SAIFTY_CLASS, // 16) Phrase: Hazard Class
  16: SEC_CANONICAL_CONCENTRATION_SAIFTY_CATEGORY, // 17) Phrase: Hazard Category
  17: SEC_CANONICAL_CONCENTRATION_SAIFTY_ROUTE_EXPO, // 18) Phrase: Route of Exposure
  18: SEC_CANONICAL_CONCENTRATION_SAIFTY_ORGAN, // 19) Phrase: Target Organs
  19: SEC_CANONICAL_CONCENTRATION_SAIFTY_HAZ_STATEMENT, // 20) Phrase: Hazard Statements
  20: SEC_CANONICAL_CONCENTRATION_SAIFTY_ADD_INFO, // 21) Phrase: Additional Information
  21: SEC_CANONICAL_M_FACTOR_SAIFTY_BASE, // 22) Phrase: M-Factor Regulatory List
  22: SEC_CANONICAL_M_FACTOR_SAIFTY_M_FACTOR, // 23) Phrase: M-Factor (Acute Aquatic Tox.)
  23: SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_CHRONIC, // 24) Phrase: M-Factor (Chron. Aquat. Tox.)
  24: SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_SOIL, // 25) Phrase: M-Factor (Soil Tox.)
  25: SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_VERT, // 26) Phrase: M-Factor (Terr. Vert. Tox.)
  26: SEC_CANONICAL_M_FACTOR_SAIFTY_MFACT_INVERT, // 27) Phrase: M-Factor (Terr. Invert. Tox.)
  27: SEC_CANONICAL_M_FACTOR_SAIFTY_REMARK, // 28) Phrase: M-Factor Remarks
  28: SEC_CANONICAL_WGK_SAIFTY_BASE, // 29) Phrase: Regulatory List
  29: SEC_CANONICAL_WGK_SAIFTY_HAZARD_CLASS, // 30) Phrase: Water Pollution Class
  30: SEC_CANONICAL_WGK_SAIFTY_IDENT_NUM, // 31) Phrase: Identification number
}

export const TEMPLATES = [
  {
    type: TemplateType.Regular,
    nameIndex: canonicalNameColumnIndex,
    mapping: XLSXCanonicalByPosition,
    rowsToIgnore: 3,
    identifierValue: 'Index No',
    identifierColumn: 0,
    identifierRow: 1,
  },
  {
    type: TemplateType.Simulation,
    nameIndex: canonicalNameColumnIndexForSimulationTemplate,
    mapping: XLSXCanonicalByPositionSimulationTemplate,
    rowsToIgnore: 2,
    identifierValue: 'CAS number',
    identifierColumn: 0,
    identifierRow: 1,
  },
]

export function getItemValueText(itemValue?: string, canonicalsConfig?: CanonicalsConfigObject[]) {
  let valueToReturn = '---'

  if (itemValue) {
    valueToReturn = itemValue.replaceAll(',', ',\n')

    // Logic to show the description name for M-Factor and Water hazard class subcanonical items
    Object.values(XLSXCanonicalByPositionSimulationTemplate).forEach((canonicalOrSubSanonical) => {
      const configFound = canonicalsConfig?.find((i) => canonicalOrSubSanonical.startsWith(i.canonical_name))
      const subCanonicalConfigFound = configFound?.add_info?.find((i) => i.cannonical_sub === canonicalOrSubSanonical)

      if (subCanonicalConfigFound && subCanonicalConfigFound.value_description) {
        valueToReturn = valueToReturn.replaceAll(
          canonicalOrSubSanonical + ':',
          subCanonicalConfigFound.value_description + ': '
        )
      } else {
        valueToReturn = valueToReturn.replaceAll(canonicalOrSubSanonical + ':', '')
      }
    })
  }

  return valueToReturn
}

export function getAssessmentItemValueText(itemValue?: string, canonicalsConfig?: CanonicalsConfigObject[]) {
  let valueToReturn = '---'

  if (itemValue) {
    valueToReturn = itemValue.replaceAll(',', ',\n')

    // Logic to show the description name for M-Factor and Water hazard class subcanonical items
    Object.values(XLSXCanonicalByPositionSimulationTemplate).forEach((canonicalOrSubSanonical) => {
      const configFound = canonicalsConfig?.find((i) => canonicalOrSubSanonical.startsWith(i.canonical_name))
      const subCanonicalConfigFound = configFound?.add_info?.find((i) => i.cannonical_sub === canonicalOrSubSanonical)

      if (subCanonicalConfigFound && subCanonicalConfigFound.value_description) {
        valueToReturn = valueToReturn.replaceAll(
          canonicalOrSubSanonical + ':',
          subCanonicalConfigFound.value_description + ': '
        )
      } else {
        valueToReturn = valueToReturn.replaceAll(canonicalOrSubSanonical + ':', '')
      }
    })
  }

  return valueToReturn
}
